import React from 'react';
import { observer } from 'mobx-react';
import withCompute from 'lib/mobx/with-compute';
import computed from 'lib/mobx/computed';
import Styled from 'styled';
import AvatarView from 'four-nets/ui/avatar-view';
import compute from 'lib/mobx/compute';

const defaultAvatar = require('../default-avatar.jpg');

export { UserAvatarViewModel };

@withCompute()
class UserAvatarViewModel {
    @compute user;
    @compute role;

    @computed get img() {
        if (this.user) {
            return this.user.avatarUrl;
        }
        return defaultAvatar;
    }
}

export default observer(function UserAvatarView(props) {
    const { userAvatarViewModel, alt } = props;
    const { user } = userAvatarViewModel;

    return <AvatarView alt={alt} user={user} />;
});
